import React, { useState } from 'react';
import styles from './service-employees-selector.module.scss';
import { CircleImage, SearchInput } from 'shared/ui';
import { CheckMarkSvg } from 'shared/svg';
import { IEmployeeInfo } from 'shared/api/business/interfaces/employee-info.interface';

interface IServiceEmployeesSelectorProps {
  employees?: IEmployeeInfo[];
  activeEmployees?: IEmployeeInfo[];
  title?: string;
  onChange: (value: IEmployeeInfo[]) => void;
}

export const ServiceEmployeesSelector: React.FC<
  IServiceEmployeesSelectorProps
> = ({ employees, activeEmployees, title = 'Заголовок', onChange }) => {
  const [inputValue, setInputValue] = useState('');
  const [selectedEmployees, setSelectedEmployees] = useState<IEmployeeInfo[]>(
    activeEmployees || []
  );

  const normalizedSearch = inputValue.toLowerCase().trim();

  const matchesSearch = (employee: IEmployeeInfo): boolean => {
    if (!normalizedSearch) return true;
    return (
      employee.fio?.toLowerCase().includes(normalizedSearch) ||
      employee.phone?.toLowerCase().includes(normalizedSearch) ||
      employee.email?.toLowerCase().includes(normalizedSearch)
    );
  };

  const toggleEmployeeSelection = (employee: IEmployeeInfo) => {
    const isSelected = selectedEmployees.some((e) => e.id === employee.id);
    const newSelected = isSelected
      ? selectedEmployees.filter((e) => e.id !== employee.id)
      : [...selectedEmployees, employee];
    setSelectedEmployees(newSelected);
    onChange(newSelected);
  };

  return (
    <div className={styles.selector__container}>
      <div className={styles.selector__title}>{title}</div>
      <div className={styles.selector__content}>
        <div className={styles.content__input}>
          <SearchInput
            value={inputValue}
            placeholder="Поиск по сотрудникам"
            onChange={setInputValue}
            containerStyles={{ height: '32px' }}
            inputStyles={{ fontSize: '15px' }}
          />
        </div>
        <div className={styles.content__selectors}>
          {employees?.filter(matchesSearch).map((employee) => {
            const isSelected = selectedEmployees.some(
              (e) => e.id === employee.id
            );
            return (
              <div
                key={employee.id}
                className={`${styles.selectors__employee} ${isSelected ? styles.selectors__employee__selected : ''}`}
                onClick={() => toggleEmployeeSelection(employee)}
              >
                <div className={styles.employee__info}>
                  <CircleImage imgSize={32} imgSrc={employee.imgUrl} />
                  <div className={styles.employee__fio}>{employee.fio}</div>
                </div>
                <div
                  className={`${styles.employee__checkbox} ${isSelected ? styles.employee__checkbox__selected : ''}`}
                >
                  {isSelected && <CheckMarkSvg />}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
